//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowContentListMediaDx",
    props: {
        ...defaultBlockProps,
    },
    data: () => ({}),
};
